
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransitionStage] = useState('fadeIn');

  useEffect(() => {
    if (location !== displayLocation) {
      setTransitionStage('fadeOut');
      
      const timeout = setTimeout(() => {
        setDisplayLocation(location);
        setTransitionStage('fadeIn');
        // Scroll to top when location changes
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 200); // Reduced transition time for snappier feel
      
      return () => clearTimeout(timeout);
    }
  }, [location, displayLocation]);

  // Also scroll to top on initial load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`page-transition ${transitionStage} min-h-screen`}>
      {children}
    </div>
  );
};

export default PageTransition;
